import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { React, useContext, createContext, useState } from 'react';
import fetchJsonp from 'fetch-jsonp';
import { jsx as _jsx } from "react/jsx-runtime";
var INITIAL_STATE = {
  options: {
    locations: [],
    regions: [],
    categories: [],
    industries: [],
    postingTypes: [],
    jobTypes: []
  },
  filters: {},
  keywords: '',
  autocomplete: ''
};
var FiltersContext = /*#__PURE__*/createContext();
export var useFiltersContext = function useFiltersContext() {
  return useContext(FiltersContext);
};

var FiltersProvider = function FiltersProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(INITIAL_STATE),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var _useState2 = useState(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var removeDuplicates = function removeDuplicates(array) {
    return array.filter(function (a, b) {
      return array.indexOf(a) === b;
    });
  };

  var onKeywordsChange = function onKeywordsChange(e) {
    (e === null || e === void 0 ? void 0 : e.target) && setFiltersState(Object.assign({}, filtersState, {
      keywords: e.target.value
    }));
  };

  var onLocationSelected = function onLocationSelected(_ref2) {
    var latitude = _ref2.latitude,
        longitude = _ref2.longitude,
        distance = _ref2.distance,
        displayName = _ref2.displayName;
    setFiltersState(Object.assign({}, filtersState, {
      autocomplete: displayName,
      filters: Object.assign({}, filtersState.filters, {
        latitude: latitude,
        longitude: longitude,
        distance: distance
      })
    }));
  };

  var onLocationChange = function onLocationChange(val) {
    !val && filtersState.filters.latitude && filtersState.filters.longitude ? setFiltersState(Object.assign({}, filtersState, {
      autocomplete: val,
      filters: Object.assign({}, filtersState.filters, {
        latitude: '',
        longitude: ''
      })
    })) : setFiltersState(Object.assign({}, filtersState, {
      autocomplete: val
    }));
  };

  var onSelectionChange = function onSelectionChange(e) {
    var _Object$assign;

    (e === null || e === void 0 ? void 0 : e.target) && setFiltersState(Object.assign({}, filtersState, {
      filters: Object.assign({}, filtersState.filters, (_Object$assign = {}, _Object$assign[e.target.name] = e.target.value !== 'All' ? e.target.value : '', _Object$assign))
    }));
  };

  var fetchOptions = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiEndpoint, groupOrIdParam, apiKey, optionNames) {
      var updatedState, _loop, _iterator, _step;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              updatedState = filtersState;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var _step$value, func, name, key;

                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _step$value = _step.value, func = _step$value.func, name = _step$value.name, key = _step$value.key;
                        _context.prev = 1;
                        _context.next = 4;
                        return fetchJsonp(apiEndpoint + '/CareerPage/' + func + '?' + groupOrIdParam + '=' + apiKey + '&region=All', {
                          timeout: 15000
                        }).then(function (response) {
                          return response.json();
                        }).then(function (jsonList) {
                          var _Object$assign2;

                          var temp = [];
                          if (!name.includes('Posting')) temp.push('All ' + name);
                          updatedState = Object.assign({}, updatedState, {
                            options: Object.assign({}, updatedState.options, (_Object$assign2 = {}, _Object$assign2[key] = temp.concat(removeDuplicates(jsonList)), _Object$assign2))
                          });
                        }).catch(function (ex) {
                          setLoading(false);
                          console.error(ex, 'error');
                        });

                      case 4:
                        _context.next = 10;
                        break;

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](1);
                        setLoading(false);
                        console.error(_context.t0.message, 'error');

                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop, null, [[1, 6]]);
              });
              _iterator = _createForOfIteratorHelperLoose(optionNames);

            case 3:
              if ((_step = _iterator()).done) {
                _context2.next = 7;
                break;
              }

              return _context2.delegateYield(_loop(), "t0", 5);

            case 5:
              _context2.next = 3;
              break;

            case 7:
              setFiltersState(updatedState);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));

    return function fetchOptions(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var resetLocation = function resetLocation() {
    setFiltersState(Object.assign({}, filtersState, {
      autocomplete: '',
      filters: Object.assign({}, filtersState.filters, {
        latitude: '',
        longitude: ''
      })
    }));
  };

  var resetFilters = function resetFilters() {
    setFiltersState(Object.assign({}, filtersState, {
      filters: {},
      keywords: '',
      autocomplete: ''
    }));
  };

  return /*#__PURE__*/_jsx(FiltersContext.Provider, {
    value: {
      filtersState: filtersState,
      setFiltersState: setFiltersState,
      loading: loading,
      setLoading: setLoading,
      fetchOptions: fetchOptions,
      onKeywordsChange: onKeywordsChange,
      onLocationSelected: onLocationSelected,
      onLocationChange: onLocationChange,
      onSelectionChange: onSelectionChange,
      resetLocation: resetLocation,
      resetFilters: resetFilters
    },
    children: children
  });
};

export default FiltersProvider;